import React from "react";
import MakingKids from "../Kids/MakingKids";
import CultivateThinking from "../Kids/CultivateThinking";
import Contactus from "../Summidence/Contantus";
import ContactKids from "../Kids/ContactKids";
import NuturingFuture from "../Kids/NuturingFuture";
const Kids = () => {
  return (
    <>
      <MakingKids />
      <CultivateThinking />
      <NuturingFuture />
      {/* <ContactKids /> */}
    </>
  );
};

export default Kids;
